var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisualStudioIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_11",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8089 4.23725L30.5245 0.248413C29.5656 -0.213293 28.4195 -0.0185352 27.6669 0.734032L0.546562 25.4615C-0.182907 26.1266 -0.182069 27.2751 0.548371 27.9391L2.76365 29.9529C3.36082 30.4959 4.26016 30.5358 4.90312 30.0481L37.5623 5.27205C38.658 4.44086 40.2317 5.22233 40.2317 6.59761V6.50142C40.2317 5.53605 39.6787 4.65603 38.8089 4.23725Z",
    fill: "#0065A9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8089 35.7629L30.5245 39.7517C29.5656 40.2133 28.4195 40.0186 27.6669 39.2661L0.546562 14.5386C-0.182907 13.8735 -0.182069 12.7251 0.548371 12.061L2.76365 10.0471C3.36082 9.50426 4.26016 9.46429 4.90312 9.95207L37.5623 34.728C38.658 35.5592 40.2317 34.7778 40.2317 33.4024V33.4987C40.2317 34.464 39.6787 35.344 38.8089 35.7629Z",
    fill: "#007ACC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5249 39.7523C29.5658 40.2136 28.4197 40.0187 27.6671 39.2661C28.5943 40.1934 30.18 39.5365 30.18 38.2251V1.7749C30.18 0.463444 28.5943 -0.19334 27.6671 0.734002C28.4197 -0.018636 29.5658 -0.213669 30.5249 0.24763L38.808 4.23098C39.6784 4.64955 40.2319 5.52988 40.2319 6.49568V33.5045C40.2319 34.4703 39.6784 35.3506 38.808 35.7691L30.5249 39.7523Z",
    fill: "#1F9CF0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_11",
    x: -21.3334,
    y: -11.722,
    width: 82.8985,
    height: 73.055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_11",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3_11",
    x: 6.33367,
    y: -21.3334,
    width: 55.2316,
    height: 82.6668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_11",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualStudioIcon);
export default __webpack_public_path__ + "static/media/visual-studio-icon.d1313a4be222a44c2ca7e6176272c0bf.svg";
export { ForwardRef as ReactComponent };